import React from 'react'
import SalesBookFilter from './components/filter'
import { Card, CardBody, CardHeader, CardTitle, Row } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { columnsTable } from './utils/data'
import Summary from './components/summary'

const SalesBook = () => {

  const data = [
    {
      dia: '01',
      delNo: '123',
      alNo: '124',
      maquina: 'Caja 1',
      noSujetas: '0',
      exentas: '100',
      gravadas: '200',
      exportaciones: '300',
      ventasTotales: '600',
      terceros: '50',
      retencion: '1',
    },
  ]
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <CardTitle tag="h2">Contribuyentes</CardTitle>
        </CardHeader>
        <CardBody>
          <SalesBookFilter />
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Row>
            <DataTable
              columns={columnsTable()}
              data={data}
              pagination
            />
          </Row>
          <Row>
            <Summary />
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default SalesBook